import React, { useState, Context, ReactElement, Component } from "react";

export interface clusters_type {
  kind: string;
  items: clusters_type_item[];
}

export interface clusters_type_item {
  kind: string;
  apiVersion: string;
  metadata: {
    name: string;
    selfLink: string;
    uid: string;
    key: string;
    resourceVersion: string | undefined;
    generation: number;
    creationTimestamp: string;
    labels: {
      datacenter: string;
      type: string;
      role?: string;
    };
    updateTime: string;
    createTime: string;
    usedCPU: string;
    usedMemory: string;
    usedRootfs: string;
    usedPod: string;
    usedDisk: string;
    usedGPU: string;
    totalCPU: string;
    totalMemory: string;
    totalRootfs: string;
    totalPod: string;
    totalDisk: string;
    totalGPU: string;
    totalNamespaces: string;
    requestCPU: string;
    requestMemory: string;
    limitCPU: string;
    limitMemory: string;
    version: string;
    agentVersion: string;
    node: string;
    workspace: string;
    namespace: string;
    user: string;
    display?: (string | number)[];
    status: string;
    clusteragentStatus: string;
  };
  subscriptionId: string;
  spec: {
    description: string;
    clientcert: {
      cert: string;
    };
    host: string;
    datacenter: string;
  };
  status: {
    status: string;
    version: string;
    oldgeneration: number;
    updatetime: string;
    clusteragentStatus: string;
  };
}

const ClusterContext: Context<[clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>]> = React.createContext<
  [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>]
>([[], (_value: any) => {}]);

const ClusterProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useState<clusters_type_item[]>([]);
  return <ClusterContext.Provider value={[clusters, set_clusters]}>{props.children}</ClusterContext.Provider>;
};

export { ClusterContext, ClusterProvider };
